import { createSlice, PayloadAction as Action } from "@reduxjs/toolkit";

import { ILocalFile } from "types";

type State = {
  loadingID?: string;
  files: ILocalFile[];
  groupedByCategories: {
    [fileID: string]: {
      [categoryName: string]: number;
    };
  };
  countedIDs: string[];
  uploadedIDs: string[];
};

const initialState: State = {
  files: [],
  countedIDs: [],
  uploadedIDs: [],
  loadingID: undefined,
  groupedByCategories: {},
};

const slice = createSlice({
  name: "placesUpload",
  initialState: initialState,
  reducers: {
    setLoadingID: (state, action: Action<State["loadingID"]>) => {
      state.loadingID = action.payload;
    },

    setLocalFiles: (state, action: Action<State["files"]>) => {
      state.files = action.payload;
    },
    setGroupedByCategories: (
      state,
      action: Action<State["groupedByCategories"]>
    ) => {
      state.groupedByCategories = action.payload;
    },
    setCountedIDs: (state, action: Action<State["countedIDs"]>) => {
      state.countedIDs = [...state.countedIDs, ...action.payload];
    },
    setUploadedIDs: (state, action: Action<State["uploadedIDs"]>) => {
      state.uploadedIDs = [...state.uploadedIDs, ...action.payload];
    },
  },
});

export const {
  reducer,
  actions: {
    setLoadingID,
    setLocalFiles,
    setCountedIDs,
    setUploadedIDs,
    setGroupedByCategories,
  },
} = slice;
